import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

import examIcon from "../../assets/svg/mdi--book-clock-outline.svg";
import inboxIcon from "../../assets/svg/material-symbols--inbox-outline-rounded.svg";
import messageIcon from "../../assets/svg/tabler--message.svg";
import InternalPopupLauncher from "../../components/Common/InternalPopupLauncher";
import TestReservationSeeder from "../../components/APanel/TestReservationSeeder";
import TestBlackoutSeeder from "../../components/APanel/TestBlackoutSeeder";
import NotificationsSeeder from "../../components/APanel/NotificationsSeeder";
import BookingSettingsCard from "../../components/APanel/BookingSettingsCard";
import DistrictsCard from "../../components/APanel/DistrictsCard";

const ADMIN_OTHER_LINKS = [
   {
      to: "/admin/mesaje-automate",
      title: "Mesaje automate",
      description:
         "Textele trimise automat elevilor: mementourile din chat, notificările din aplicație și emailurile.",
      icon: messageIcon,
      meta: "Chat · Notificări · Email",
   },
   {
      to: "/admin/inbox",
      title: "Inbox",
      description: "Mesajele și notificările platformei.",
      icon: inboxIcon,
      meta: "Comunicare",
   },
   {
      to: "/admin/corectare-teorie",
      title: "Corectare teorie",
      description:
         "Importă patch JSON și corectează limba rusă pentru biletele de practică (P1–P24).",
      icon: examIcon,
      meta: "Practică RU",
   },
   {
      to: "/admin/corectare-exam",
      title: "Corectare",
      description:
         "Instrumentul pentru corectarea și verificarea întrebărilor de examen.",
      icon: examIcon,
      meta: "Pagină mutată",
   },
];

export default function APAltele() {
   useEffect(() => {
      document.title = "Instruire Auto | Instrumente";
   }, []);

   return (
      <main className="main">
         <section className="adminOther">
            <div className="adminOther__hero">
               <div className="adminOther__heroText">
                  <p className="adminOther__eyebrow">Admin</p>
                  <h1 className="adminOther__title">Instrumente</h1>
                  <p className="adminOther__subtitle">
                     Pagini secundare și preview-uri pentru popup-urile din
                     platformă.
                  </p>
               </div>
            </div>

            <section className="adminOther__section">
               <div className="adminOther__sectionHead">
                  <h2>Pagini</h2>
                  <p>
                     Linkuri mutate din header ca meniul principal să rămână
                     curat.
                  </p>
               </div>

               <div className="adminOther__links">
                  {ADMIN_OTHER_LINKS.map((item) => (
                     <NavLink
                        key={item.to}
                        to={item.to}
                        className="adminOther__linkCard"
                     >
                        <span className="adminOther__linkIcon">
                           <img src={item.icon} alt="" aria-hidden="true" />
                        </span>
                        <span className="adminOther__linkBody">
                           <span className="adminOther__linkMeta">
                              {item.meta}
                           </span>
                           <span className="adminOther__linkTitle">
                              {item.title}
                           </span>
                           <span className="adminOther__linkDescription">
                              {item.description}
                           </span>
                        </span>
                     </NavLink>
                  ))}
               </div>
            </section>

            <BookingSettingsCard />

            <DistrictsCard />

            <section className="adminOther__section">
               <div className="adminOther__sectionHead">
                  <h2>Test calendar</h2>
                  <p>
                     Umple o lună cu rezervări și blocări pe date existente, în
                     batch-uri, pentru stres-test pe grafic.
                  </p>
               </div>
               <div className="adminOther__seeders">
                  <TestReservationSeeder />
                  <TestBlackoutSeeder />
               </div>
            </section>

            <section className="adminOther__section">
               <div className="adminOther__sectionHead">
                  <h2>Notificări</h2>
                  <p>
                     Creează notificări reale în DB (document-ready /
                     test-tomorrow) și comută modul demo.
                  </p>
               </div>
               <div className="adminOther__seeders">
                  <NotificationsSeeder />
               </div>
            </section>

            <section className="adminOther__section">
               <div className="adminOther__sectionHead">
                  <h2>Preview popup-uri</h2>
                  <p>
                     Deschide rapid popup-urile existente pentru verificare UI
                     și stilizare.
                  </p>
               </div>

               <InternalPopupLauncher />
            </section>
         </section>
      </main>
   );
}
